import React from "react";
import { withTranslate } from "react-redux-multilingual"

const NoData = ({ image, translate }) => {

    return (
        <div className="text-center" style={{ display: 'block', textAlign: 'center', width: '100%' }}>
            <img src={ '/images/' + image + ".png" } alt="no data" />
            <p className="capitalized" style={{ marginTop: '20px', textAlign: 'center' }}>{ translate("no_data") }</p>
        </div>
    )
}


export default withTranslate(NoData);